export default {
    DEBUG:false,
    URL_PREFIX:(process.env.NODE_ENV === 'production')?"":"",
    URL:"https://hitziggrad.de/",
    EMAIL:"katrin@zukunftsoptimisten.de",
    TEL:"+4917683054861",
    STATE_DEFAULT:"Deutschland",
    LOCATION_DEFAULT_IMAGE:"/img/backgrounds/default.jpg",
}